export default __webpack_public_path__ + "static/media/Payroll-1.44d6729e.png";